module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Light.043a373.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Light.ttf
// module id = Zeop
// module chunks = 1